<template>
  <div class="row">
    <form @submit.prevent="login" novalidate="novalidate">
      <div class="col-12 q-pa-md">
        <p>{{ getString('email_address') }}</p>
        <q-field>
          <q-input
            color="white"
            type="email"
            :placeholder="getString('email_address')"
            inverted-light
            v-model="email"
            class="no-shadow bg-grey-11"
          />
        </q-field>
      </div>
      <div class="col-12 q-pa-md">
        <p>{{ getString('password_str') }}</p>
        <q-field>
          <q-input
            color="white"
            type="password"
            :placeholder="getString('password_str')"
            inverted-light
            v-model="password"
            class="no-shadow bg-grey-11"
          />
        </q-field>
      </div>
      <div class="no-padding error" :class="{ active: errorOpen }">
        <div class="row">
          <div class="col-12 q-pa-md">
            <div class="error-inner">
              <span class="text-weight-bold error-title">
                {{ getString('login.input.error.head') }}
              </span>
              <p class="error-body">
                {{ getString('login.input.error.message') }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 q-pa-md">
        <q-btn
          align="right"
          color="primary"
          :label="getString('login.input.button')"
          size="md"
          type="submit"
          class="float-right capitalize"
        />
      </div>
    </form>
  </div>
</template>

<script>

// Imports
import { minLength, required, email } from 'vuelidate/lib/validators';
import getString from '@/helpers/GetStrings';

export default {
  name: 'Login',
  data() {
    return {
      email: process.env.NODE_ENV === 'production' ? '' : 'matthew@superlatief.nl',
      password: process.env.NODE_ENV === 'production' ? '' : '1234567890',
      errorOpen: false,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      minLength: minLength(10),
    },
  },
  methods: {
    getString,
    // Function to login
    login() {
    // Validate
      this.$v.$touch();

      // Errors in form
      if (this.$v.$invalid) {
        this.errorOpen = true;

        // No errors in form
      } else {
      // Show loader
        this.$q.loading.show();
        // Dispatch login action
        this.$store.dispatch('authLogin', { email: this.email, password: this.password })
          .then(() => {
            // Hide loader
            this.$q.loading.hide();
            this.$router.push('/dashboard');
          })
          .catch(() => {
            this.$q.loading.hide();
            this.errorOpen = true;
          });
      }
    },
  },
  watch: {
    // This watcher closes the error-message afer 3 seconds if errorOpen is set to true
    errorOpen(val) {
      if (val === true) {
        setTimeout(() => {
          this.errorOpen = false;
        }, 3000);
      }
    },
  },
};

</script>

<style lang="stylus">
@import '~variables';

.error {
  width: calc(100% + 1rem);
  margin-left: -0.5rem;
  background-color: $ctrl-red;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s ease;

  &.active {
    max-height: 1000px;
  }
}

.error-inner {
  padding-left: 1rem;
  padding-right: 1rem;
}

.error-title {
  color: rgba(0, 0, 0, 0.55);
  text-shadow: hsla(0, 0%, 100%, 0.1) 0 1px 0;
  margin-bottom: 0.5rem;
  display: inline-block;
}

.error-body {
  color: rgba(0, 0, 0, 0.55);
  text-shadow: hsla(0, 0%, 100%, 0.1) 0 1px 0;
  margin-bottom: 0;
}
</style>
